import "./MenuSlidingPanel.js";
import { useEffect as e, useRef as t, useState as n } from "react";
//#region src/components/Header/mobile/usePortalClosing.ts
var r = (r, i) => {
	let [a, o] = n(!1), s = t(void 0);
	return e(() => () => clearTimeout(s.current), []), {
		willOpen: r || a,
		handleOpenChange: (e) => {
			!e && r ? (o(!0), clearTimeout(s.current), s.current = setTimeout(() => {
				i(!1), o(!1);
			}, 150)) : e && i(!0);
		}
	};
};
//#endregion
export { r as usePortalClosing };
